function setHtmlSize() {
    var clientWidth = document.documentElement.clientWidth;
    var dpr = window.devicePixelRatio || 1;
    var htmlFontSize = clientWidth * dpr / 10 * (1 / dpr);
    // console.log(dpr);
    document.getElementsByTagName("html")[0].style.fontSize = htmlFontSize + "px";
}
window.onresize = function () {
    setHtmlSize();
}
setHtmlSize();
